import CustomHead from 'components/common/HeadMeta/HeadMeta'
import Template from 'components/LP/LP202407/Thanks'
import useLocalStorage from 'hooks/useLocalStorage'

const Thanks: React.FC = () => {
  const fromCorrectFormPage = useLocalStorage('refZebraLpContactPage')
  return (
    <>
      {fromCorrectFormPage ? (
        <CustomHead
          keyword={'ZEBRA プッシュ通知 配信 モバイルアプリ iPhone Android 安い'}
          image={'https://aitria.co.jp/img/ogp_zebra.png'}
          url={'https://aitria.co.jp/products/zebra/thanks/'}
          title="送信完了 ZEBRA | サービス | Aitria（アイトリア）"
          description="シンプルで直感的に使いやすいプッシュ通知サービスの決定版。顧客属性DBを活用し、細やかなセグメント配信で効果的なコミュニケーションを実現します。"
          favicon="/favicon_zebra.png"
        />
      ) : (
        <></>
      )}
      <Template />
    </>
  )
}

export default Thanks
